import { Fragment } from 'react';
import { Typography } from '@mui/material';

import RowContainer from '../../components/RowContainer';

import SectionTitle from '../../components/SectionTitle';

const PatientInfo = () => {
  return (
    <Fragment>
      <SectionTitle title="1. Lý do sử dụng sự kiềm chế bằng phương pháp vật lý" />
      <RowContainer xs={11.5} sx={{ margin: '20px 0px 30px 0px' }}>
        <Typography
          sx={{ lineHeight: '20px', margin: '20px 0 0 15px', fontSize: '14px' }}
        >
          Bệnh nhân nhập viện thường bị suy giảm chức năng nhận thức và khả năng
          vận động do tính chất của bệnh. Do đó, họ có thể cố gắng loại bỏ hoặc
          làm hỏng các thiết bị điều trị. Nhiều
          <br />
          nỗ lực đã được thực hiện để giải quyết vấn đề này, nhưng có những tình
          huống cần phải sử dụng các biện pháp kiềm chế bằng phương pháp vật lý
          tối thiểu.
        </Typography>
      </RowContainer>
    </Fragment>
  );
};

export default PatientInfo;
